<template>
  <div class="scene-export-box">
    <div class="header-box">
      <div class="tip-box">
        <div class="public-tips-primary">
          注：1. 列表只显示发布成功的场景，未发布场景已被过滤
        </div>
        <div class="public-tips-primary">
          2. 导出时会将场景内包含的所有数据全部导出成一个资源包
        </div>
      </div>
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          placeholder="请输入名称搜索"
          v-model="sceneName"
          clearable
          @clear="search"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search" />
        </el-input>
      </div>
    </div>
    <div
      class="common-table-box"
      v-if="!loading">
      <el-table
        height="100%"
        highlight-selection-row
        class="publish-table"
        row-key="id"
        :data="sceneList"
        @select="selectChange"
        @select-all="selectChange">
        <el-table-column
          type="selection"
          width="60" />
        <el-table-column
          label="序号"
          type="index"
          width="55" />
        <el-table-column
          label="场景名称"
          width="280">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="row.sceneName">
              {{ row.sceneName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="显示方式">
          <template v-slot="{ row }">
            <div>
              {{ row.displayMode === 'Sphere' ? '三维球体' : '平面' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="坐标系"
          width="200">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="`${row.coordinates ? row.coordinates : '--'}`">
              {{ row.coordinates ? row.coordinates : '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="180">
          <template v-slot="{ row }">
            <div>
              {{ formatTime(row.creationTime) }}
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
      <div class="common-pagination-box">
        <el-pagination
          class="pagination-primary"
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currPage"
          :total="total"
          @size-change="pageSizeChange"
          @current-change="pageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/generalMethods'

import { getOfflineSceneSelectListService } from '@/service/interface'

export default {
  data() {
    return {
      loading: false,
      sceneList: [],
      selectScenes: [],

      sceneName: '',
      currPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  props: {
    projId: String
  },
  methods: {
    updateSceneList() {
      this.querySceneList().then(sceneList => {
        this.sceneList = sceneList
      })
    },
    search() {
      this.currPage = 1
      this.updateSceneList()
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.updateSceneList()
    },
    pageSizeChange(pageSize) {
      this.currPage = 1
      this.pageSize = pageSize
      this.updateSceneList()
    },
    selectChange(scenes) {
      this.selectScenes = scenes
    },
    getExportSceneInfo() {
      let scenes = this.selectScenes
      let exportSceneInfo = { scenes }
      return exportSceneInfo
    },
    querySceneList() {
      return new Promise(resolve => {
        if (!this.projId) {
          this.total = 0
          resolve([])
          return
        }
        let params = {
          resultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize,
          projId: this.projId,
          sceneName: this.sceneName
        }
        getOfflineSceneSelectListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let sceneList = data.items
            this.total = data.totalCount
            resolve(sceneList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.scene-export-box {
  height: 100%;
  margin-top: 6px;

  .header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tip-box {
      font-size: 12px;
      color: var(--page-tips-text-color);

      .text-box:last-child {
        margin-left: 29px;
      }
    }
  }

  .common-table-box {
    margin-top: 16px;
    height: calc(100% - 54px);

    .publish-table {
      height: calc(100% - 69px) !important;
    }

    .common-pagination-box {
      text-align: center;

      .pagination-primary {
        margin-left: 0;
        width: 100%;
        margin-right: 0;
      }
    }
  }
}
</style>
